import React from 'react';
// Components
import Skeleton from 'react-loading-skeleton';

function StandardOfferAccommodationSkeleton({ count = 4 }) {
    return (
        <div className="standardOfferAccommodation">
            <div className="featuredAccommodation--header">
                <h2>
                    <Skeleton width={220} height={26} />
                </h2>
                <span className="featured-accommodation__header-line" />
                <span className="featuredAccommodation__see-more">
                    <Skeleton width={110} height={18} />
                </span>
            </div>

            <div className="featuredAccommodation__items-container">
                <div className="featuredAccommodation__items">
                    {Array.from({ length: count }).map((_, index) => (
                        <Skeleton key={index} containerClassName="featuredAccommodation__items-item" height={291} />
                    ))}
                </div>
            </div>
        </div>
    );
}

export default StandardOfferAccommodationSkeleton;
